// Toaster: the toast stack at the bottom of the screen and its polite live
// region. Mount it once, beside the app; it holds no context.

import { useToastStore } from '../../hooks/useToast';
import Toast from './Toast';

export default function Toaster() {
  const { toasts, removeToast, politeSeq } = useToastStore();

  // A polite live region is only announced when text changes inside a node
  // that was already in the tree — a region minted with its card stays silent.
  // So one region outlives every toast and carries the newest non-error
  // message; errors interrupt through their own role="alert" on the card.
  // A repeat replaces the top toast with the same text, and identical text is
  // no DOM mutation, so nothing is re-announced. Alternating an invisible
  // zero-width space per emission makes every repeat a change the reader sees.
  const polite = toasts.filter((t) => t.type !== 'error').at(-1);
  const politeMessage = polite ? polite.message + (politeSeq % 2 ? '\u200B' : '') : '';

  return (
    <>
      <p role="status" aria-live="polite" className="sr-only">
        {politeMessage}
      </p>

      {/* Toast Container */}
      <div
        className="fixed bottom-0 left-0 right-0 z-[60] pointer-events-none"
        style={{
          paddingBottom: 'max(1rem, env(safe-area-inset-bottom))',
        }}
      >
        <div className="flex flex-col items-center gap-2 px-4">
          {/* Taps pass through everywhere except the toast card itself —
              a full-width interactive band here swallowed bottom-edge taps
              on small phones (#289). */}
          {toasts.map((toast) => (
            <div key={toast.id} className="w-full flex justify-center animate-slide-up">
              <Toast toast={toast} onDismiss={removeToast} />
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
